import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c9f2f7a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  key: 0,
  class: "type1"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "温馨提示", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "未开通VIP暂时无法使用", -1));
const _hoisted_5 = {
  key: 1,
  class: "type2"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "开通VIP", -1));
const _hoisted_7 = {
  class: "content"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "余额", -1));
const _hoisted_9 = ["onClick"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "支付金额", -1));
const _hoisted_11 = {
  class: "active"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
    onClosed: _ctx.closePop,
    show: _ctx.show,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => _ctx.show = $event),
    class: "mask"
  }, {
    default: _withCtx(() => [_ctx.type === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createVNode(_component_van_button, {
      onClick: _cache[0] || (_cache[0] = $event => _ctx.type = 2),
      style: {
        "width": "100%"
      },
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode("开通VIP")]),
      _: 1
    })])) : _createCommentVNode("", true), _ctx.type === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("nav", null, [_createElementVNode("a", {
      onClick: _cache[1] || (_cache[1] = $event => _ctx.active = _ctx.vipMoney),
      class: _normalizeClass({
        active: _ctx.active === _ctx.vipMoney
      })
    }, [_createVNode(_component_van_icon, {
      color: "#48b338",
      size: "40",
      name: "user"
    }), _hoisted_8], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vipMethod, (item, index) => {
      return _openBlock(), _createElementBlock("a", {
        key: index,
        onClick: $event => _ctx.active = item,
        class: _normalizeClass({
          active: _ctx.active === item
        })
      }, [_createVNode(_component_van_icon, {
        color: item === '2' ? '#48b338' : item === '3' ? '#06b4fd' : '',
        size: "40",
        name: item === '2' ? 'wechat-pay' : item === '3' ? 'alipay' : item === '10' ? require('@/assets/img/user/cloudPay.png') : ''
      }, null, 8, ["color", "name"]), _createElementVNode("span", null, _toDisplayString(item === "2" ? "微信" : item === "3" ? "支付宝" : item === "10" ? "云闪付" : ""), 1)], 10, _hoisted_9);
    }), 128))]), _hoisted_10, _createElementVNode("ul", null, [_createElementVNode("li", _hoisted_11, _toDisplayString(_ctx.buyMoney), 1)])]), _createVNode(_component_van_button, {
      onClick: _cache[2] || (_cache[2] = $event => _ctx.buyOrder()),
      style: {
        "width": "250px"
      },
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode("下一步")]),
      _: 1
    })])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["onClosed", "show"])]);
}